import React, {Component} from 'react'
import "./feedback.css";
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css";
import swal from "sweetalert";
//import { Feedback } from 'react-bootstrap/lib/FormControl';


class Feedback extends Component
{
  constructor() {
    super();
    this.state = {
      fields: {},
      errors: {}
    }

    this.handleChange = this.handleChange.bind(this);
    this.submituserRegistrationForm = this.submituserRegistrationForm.bind(this);

  };
  handleChange(e) {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });

  }
  submituserRegistrationForm(e) {
    e.preventDefault();
    if (this.validateForm()) {
        let fields = {};
        fields["firstname"] = "";
        fields["lastname"] = "";
        fields["emailid"] = "";
        fields["mobileno"] = "";
        
        this.setState({fields:fields});

        //alert("Form submitted");
        this.feedbackdata()

    }

  }
  feedbackdata()
  {
      
    var feedbackData={
      firstName:document.getElementById('fstname').value,
      lastName:document.getElementById('lstname').value,
      mobileNumber:document.getElementById('mobnum').value,
      emailId:document.getElementById('emlid').value,
      yourmessage:document.getElementById('comment').value,
       deparment :document.getElementById('deparmentname').value,
       schemas:document.getElementById('schema').value

     }
     console.log(feedbackData,"check")
      axios.post('https://s3b9ssq57b.execute-api.ap-south-1.amazonaws.com/dev/userfeedBack',feedbackData)
      .then(response => { 
        console.log(response,"hello")
        if (response.data.statuscode === 200) {
          swal({
            title: "Success",
            text: "Thank you  for your Feedback",
            icon: "success",
            dangerMode: true
         
          }).then(function() {
            window.location = "/";
        });
        }
        else
        {
            swal({
              title:"Oops...",
              text:"Something went wrong. Please try again later",
              icon:"error",
              dangerMode:true
            })
        }


      })

    }



  validateForm() {

    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["firstname"]) {
      formIsValid = false;
      errors["firstname"] = "*Please enter your firstname.";
    }

    if (typeof fields["firstname"] !== "undefined") {
      if (!fields["firstname"].match(/^[a-zA-Z ]*$/)) {
        formIsValid = false;
        errors["firstname"] = "*Please enter alphabet characters only.";
      }
    }
    
    if (!fields["lastname"]) {
      formIsValid = false;
      errors["lastname"] = "*Please enter your lastname.";
    }
     
    if (typeof fields["lastname"] !== "undefined") {
      if (!fields["lastname"].match(/^[a-zA-Z ]*$/)) {
        formIsValid = false;
        errors["lastname"] = "*Please enter alphabet characters only.";
      }
    }


    if (!fields["emailid"]) {
      formIsValid = false;
      errors["emailid"] = "*Please enter your email-ID.";
    }

    if (typeof fields["emailid"] !== "undefined") {
      //regular expression for email validation
      var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
      if (!pattern.test(fields["emailid"])) {
        formIsValid = false;
        errors["emailid"] = "*Please enter valid email-ID.";
      }
    }

    if (!fields["mobileno"]) {
      formIsValid = false;
      errors["mobileno"] = "*Please enter your mobile no.";
    }

    if (typeof fields["mobileno"] !== "undefined") {
      if (!fields["mobileno"].match(/^[0-9]{10}$/)) {
        formIsValid = false;
        errors["mobileno"] = "*Please enter valid mobile no.";
      }
    }

    // if (!fields["password"]) {
    //   formIsValid = false;
    //   errors["password"] = "*Please enter your password.";
    // }

    // if (typeof fields["password"] !== "undefined") {
    //   if (!fields["password"].match(/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/)) {
    //     formIsValid = false;
    //     errors["password"] = "*Please enter secure and strong password.";
    //   }
    // }

    this.setState({
      errors: errors
    });
    return formIsValid;


  }

  render()
  {
    return(
      <div id="register">
         <div className="maindiv">
        <div className="feedheding">FEEDBACK</div>
        <div className="feedwelcls">Welcome</div>

        <div className="subdiv">
          
            <div class="container-fluid">
              <div class="row p-3">
                <div class="col-md-6">
                  <div className="feedback-leftdiv">
                    <input
                      type="text"
                      id="fstname"
                      class="form-control"
                      placeholder="First name*"
                      name="firstname" value={this.state.fields.firstname} onChange={this.handleChange}
                    />
                     <div className="error">{this.state.errors.firstname}</div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div className="feedback-rightdiv">
                    <input
                      type="text"
                      id="lstname"
                      class="form-control"
                      placeholder="Last name*"
                      name='lastname' value={this.state.fields.lastname} onChange={this.handleChange}
                    />
                     <div className="error">{this.state.errors.lastname}</div>
                  </div>
                </div>
              </div>

              <div class="row p-3">
                <div class="col-md-6">
                  <div className="feedback-leftdiv">
                    <input
                      type="text"
                      maxLength="10"
                      class="form-control"
                      id="mobnum"
                      name="mobileno" value={this.state.fields.mobileno} onChange={this.handleChange} 
                      placeholder="Mobile number*"
                      
                    />
                 <div className="error">{this.state.errors.mobileno}</div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div className="feedback-rightdiv">
                    <input
                      type="text"
                      id="emlid"
                      class="form-control"
                      placeholder="Email id*"
                      name="emailid" value={this.state.fields.emailid} onChange={this.handleChange} 
                    />
                       <div className="error">{this.state.errors.emailid}</div>
                  </div>
               
                </div>
              </div>
              {/* new */}

              <div class="row p-3">
                <div class="col-md-6">
                  <div className="select-box selectdrop feedback-leftdiv">
                    <select id="deparmentname">
                      <option selected="selected" hidden>
                        Deparment Name
                      </option>
                      <option>Labour Department</option>
                      <option>Backward Class Welfare</option>
                      <option>Skill Development</option>
                      <option>Department of Youth Empowerment and Sports</option>
                      <option>Karnataka Maharshi Valmiki Scheduled Tribes Development Corporation</option>
                    </select>
                    
                    </div>
                   
                </div>

                <div class="col-md-6">
                  <div className="select-box selectdrop feedback-rightdiv feedbackPadLeft">
                    <select id="schema">
                      <option selected="selected" hidden>
                      Scheme
                      </option>
                      <option>Ashadeepa Yojane</option>
                      <option>1. Vidyasri, 2. Fee Concession, 3. Post Matric Scholarship</option>
                      <option>Chief Ministers Kaushalya Karnataka Yojane [CMKKY]</option>
                      <option>Assistance to Institution for Technology Training [AITT- SCP/TSP]</option>
                      <option>Specialised Skill Development Institutions[SSDI]</option>
                      <option>DAY-NULM</option>
                      <option>Entrepreneurship Development Programmes</option>
                      <option>DDUGKY</option>
                      <option>Sports Scholarship</option>
                      <option>Fee Re-imbursement</option>
                      <option>Reservation for Sports quota in Professional Courses: (CET)</option>
                      <option> Karnataka Kreeda Rathna Award</option>
                      <option>Life Time Achievement Award</option>
                      <option>Sports Academy of Excellence</option>
                      <option>Ekalavya Awards</option>
                      <option>Self-employment - Entrepreneurship Development Scheme</option>
                      <option>Airavata Scheme</option>
                      <option>Samriddhi Scheme</option>
                      <option>Land ownership Scheme (Pruthvi)</option>
                      <option>Micro- Credit Scheme (Prerana)</option>
                      <option>Coffee Planters’ Comprehensive Development Scheme</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div className="yourmessage">
                  <textarea
                    class="form-control"
                    rows="3"
                    placeholder="Your message*"
                    id="comment"
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="subbtn">
              <button className="submitbtnpd" onClick={this.submituserRegistrationForm}>Submit</button>

            </div>
            </div>
        </div>
      </div>
    )
  }

}
export default Feedback